import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {MODAL_STEPS} from "@/constants/steps";
import {FaqAccordionList} from "@/customComponents/sharedComponents/PopularQuestions.jsx";
import {getFaqsForFlow, getTripDirection, FAQ_INLINE_COUNT} from "@/constants/faqs.js";
import {POLICY_CONSTANTS} from "@/constants/booking";

// Mobile step for the "More" popular-questions popup (desktop renders it inline
// as the faqModal .upper-modal in selectedCarDetailsLatest). Reuses the same
// FaqAccordionList + POPULAR_QUESTIONS data — only the shell differs.
export function PopularQuestions(props) {
    const faqs = getFaqsForFlow(getTripDirection(), {
        freeCancellationAvailable: POLICY_CONSTANTS.FREE_CANCELLATION_AVAILABLE,
        freeCancellationHours: POLICY_CONSTANTS.FREE_CANCELLATION_HOURS,
        freeEditsCount: POLICY_CONSTANTS.FREE_EDITS_COUNT,
        editableHoursBeforePickup: POLICY_CONSTANTS.EDITABLE_HOURS_BEFORE_PICKUP,
        waitingPickupFreeSeconds: POLICY_CONSTANTS.WAITING_PICKUP_FREE_SECONDS,
        waitingPickupRateCentsPerSecond: POLICY_CONSTANTS.WAITING_PICKUP_RATE_CENTS_PER_SECOND,
        waitingPickupMaxWaitSeconds: POLICY_CONSTANTS.WAITING_PICKUP_MAX_WAIT_SECONDS,
    });
    return (
        <>
            <ModalHeader
                title="Popular questions"
                extraClasses="less-space"
                totalSteps={0}
                cancelButton={false}
                backStep={MODAL_STEPS.SELECTED_CAR_DETAILS}
                showBackButton={true}
                setStep={props.setStep}
                closeModal={props.closeModal}
            />

            <div className="modalPages-spacing padding-bottom-30">
                <div className="hopn-ride-latest">
                    <div className="hopn-ride-faq">
                        <FaqAccordionList items={faqs.slice(FAQ_INLINE_COUNT)}/>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PopularQuestions;
